"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setLanguage;
exports.SET_LANGUAGE = void 0;
var SET_LANGUAGE = 'WEB_CHAT/SET_LANGUAGE';
exports.SET_LANGUAGE = SET_LANGUAGE;

function setLanguage(language) {
  return {
    type: SET_LANGUAGE,
    payload: {
      language: language
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldExhbmd1YWdlLmpzIl0sIm5hbWVzIjpbIlNFVF9MQU5HVUFHRSIsInNldExhbmd1YWdlIiwibGFuZ3VhZ2UiLCJ0eXBlIiwicGF5bG9hZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFlBQVksR0FBRyx1QkFBckI7OztBQUVlLFNBQVNDLFdBQVQsQ0FBcUJDLFFBQXJCLEVBQStCO0FBQzVDLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFSCxZQUREO0FBRUxJLElBQUFBLE9BQU8sRUFBRTtBQUFFRixNQUFBQSxRQUFRLEVBQVJBO0FBQUY7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfTEFOR1VBR0UgPSAnV0VCX0NIQVQvU0VUX0xBTkdVQUdFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0TGFuZ3VhZ2UobGFuZ3VhZ2UpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfTEFOR1VBR0UsXG4gICAgcGF5bG9hZDogeyBsYW5ndWFnZSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9MQU5HVUFHRSB9O1xuIl19